import { useEffect, useState } from "react";
import { api, formatRand } from "../../lib/api";

const Stat = ({ label, value, testId }) => (
  <div className="border hairline p-6" style={{ background: "#fff" }}>
    <div className="overline text-black/55">{label}</div>
    <div className="font-display text-4xl mt-3" data-testid={testId}>{value}</div>
  </div>
);

const AdminOverview = () => {
  const [stats, setStats] = useState(null);
  const [recentOrders, setRecentOrders] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
    api.get("/admin/orders").then((r) => setRecentOrders(r.data.slice(0, 5)));
  }, []);

  return (
    <div data-testid="admin-overview">
      <div className="border-b hairline pb-6 mb-8">
        <div className="overline mb-2">Dashboard</div>
        <h1 className="font-display text-4xl uppercase tracking-tighter">Overview</h1>
      </div>
      <div className="grid gap-4 grid-cols-2 lg:grid-cols-5">
        <Stat label="Products" value={stats?.total_products ?? "—"} testId="stat-products" />
        <Stat label="Orders" value={stats?.total_orders ?? "—"} testId="stat-orders" />
        <Stat label="Pending Payment" value={stats?.pending_orders ?? "—"} testId="stat-pending" />
        <Stat label="Members" value={stats?.total_members ?? "—"} testId="stat-members" />
        <Stat label="Subscribers" value={stats?.total_subscribers ?? "—"} testId="stat-subs" />
      </div>
      <div className="mt-10">
        <div className="overline mb-3 text-black/55">Recent Orders</div>
        <div className="border hairline" style={{ background: "#fff" }}>
          <table className="admin-table">
            <thead>
              <tr><th>Order</th><th>Customer</th><th>Total</th><th>Status</th><th>Date</th></tr>
            </thead>
            <tbody>
              {recentOrders.length === 0 ? (
                <tr><td colSpan={5} className="text-center text-black/40 py-6">No orders yet</td></tr>
              ) : recentOrders.map((o) => (
                <tr key={o.id} data-testid={`recent-order-${o.order_number}`}>
                  <td className="font-display">{o.order_number}</td>
                  <td>{o.customer_name}<br/><span className="text-xs text-black/55">{o.customer_email}</span></td>
                  <td className="font-display">{formatRand(o.total)}</td>
                  <td><span className="status-pill muted">{o.status.replace("_", " ")}</span></td>
                  <td className="text-xs text-black/55">{new Date(o.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminOverview;
